import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appLineCheck]',
})
export class LineCheckDirective implements AfterViewInit {
    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        // Use a timeout to ensure the view is fully rendered
        setTimeout(() => {
            this.checkLines();
        }, 0);
    }

    private checkLines(): void {
        const element = this.el.nativeElement;
        const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
        if (lineHeight) {
            const numLines = Math.round(element.scrollHeight / lineHeight);
            if (numLines === 1) {
                this.renderer.addClass(element, 'single-line');
            } else {
                this.renderer.removeClass(element, 'single-line');
            }
        }
    }
}
